import {useEffect,useRef,useState} from 'react';
import {consultarDashboard} from './dashboardRecepcaoApi';

// A consulta operacional continua com seu intervalo atual. Apenas um pedido
// separado pede a renovacao quando o cache expira; o servidor limita a 5 minutos.
export default function useAuditoriaDashboard(cache,painelPronto) {
  const [atualizado,setAtualizado]=useState(null),[erro,setErro]=useState('');
  const tentativa=useRef({chave:null,quando:0,pedido:null}),melhor=useRef(null);
  useEffect(()=>{
    if(!painelPronto||!cache)return;
    if(!cache.desatualizado){setErro('');return;}
    if(document.visibilityState!=='visible')return;
    const chave=cache.recalculado_em||'inicial';
    const recente=tentativa.current.chave===chave&&Date.now()-tentativa.current.quando<60000;
    if(recente&&!tentativa.current.pedido)return;
    const pedido=recente?tentativa.current.pedido:consultarDashboard('auditoria_cc');
    if(!recente)tentativa.current={chave,quando:Date.now(),pedido};let ativo=true;
    pedido.then(r=>{if(ativo){setAtualizado(r.auditoria_cc);setErro(r.auditoria_cc?.erro||'');}}).catch(e=>{if(ativo)setErro(e.message);}).finally(()=>{if(tentativa.current.pedido===pedido)tentativa.current.pedido=null;});
    return()=>{ativo=false;};
  },[cache,painelPronto]);
  for(const r of [cache,atualizado])if(r&&r.disponivel!==false&&(!melhor.current||Number(r.versao||0)>=Number(melhor.current.versao||0)))melhor.current=r;
  return {dados:melhor.current,erro:cache?.erro||erro};
}
